/**
 * Backdated Lightspeed Sales Report
 *
 * Detects sales where the sale date is backdated relative to the
 * Lightspeed creation date.
 */
import BaseReportPage, { ColumnDef, ColumnGroup } from './BaseReportPage'
import { MIN_GAP_DAYS_OPTIONS } from '../../../../components/shared/filters/types'
import { buildRowInspectorLink } from '../../../../utils/urls'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code', link: { builder: buildRowInspectorLink, external: false } },
  { key: 'franchise_name', label: 'Franchise' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'fp_status', label: 'FP Status' },
  { key: 'market', label: 'Market' },
  { key: 'invoice_number', label: 'Invoice #', link: { field: 'lightspeed_sale_link', system: 'lightspeed' } },
  { key: 'sale_date', label: 'Sale Date', type: 'business_date' },
  { key: 'ls_created_at_date', label: 'Created Date', type: 'date' },
  { key: 'gap_days', label: 'Gap (Days)', type: 'integer', colorBands: [
    { min: 1, max: 7, bg: '#fff3e0', text: '#E65100' },
    { min: 8, max: 30, bg: '#fef0ef', text: '#B71C1C' },
    { min: 31, bg: '#ffebee', text: '#880E4F' },
  ] },
  { key: 'gap_months', label: 'Gap (Months)', type: 'integer', colorBands: [
    { min: 1, max: 1, bg: '#fff3e0', text: '#E65100' },
    { min: 2, max: 3, bg: '#fef0ef', text: '#B71C1C' },
    { min: 4, bg: '#ffebee', text: '#880E4F' },
  ] },
  { key: 'total_amount_incl_tax', label: 'Amount (Inc Tax)', type: 'currency' },
  { key: 'status', label: 'Sale Status' },
  { key: 'source', label: 'Source', filterable: true },
]

const columnGroups: ColumnGroup[] = [
  { label: null, columnKeys: ['fp_code', 'franchise_name', 'last_sync_at', 'fp_status', 'market'] },
  { label: 'Sale', columnKeys: ['invoice_number', 'sale_date', 'ls_created_at_date', 'gap_days', 'gap_months'] },
  { label: 'Financial', columnKeys: ['total_amount_incl_tax', 'status', 'source'] },
]

export default function BackdatedSalesReport() {
  return (
    <BaseReportPage
      reportType="backdated_sales"
      title="Backdated Lightspeed Sales"
      description="Sales where the sale date is backdated relative to the Lightspeed creation date."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        showDateRange: true,
        requireDateRange: true,
        defaultDateRange: 'previous_month',
        linkFpStatusToSearch: true,
        showMinGapDays: true,
        minGapDaysOptions: MIN_GAP_DAYS_OPTIONS,
        defaultMinGapDays: '14',
      }}
      columns={columns}
      columnGroups={columnGroups}
      defaultSortColumn="gap_days"
      defaultSortDirection="desc"
    />
  )
}
